import { render, staticRenderFns } from "./done.vue?vue&type=template&id=1b9cc57a&scoped=true&"
import script from "./done.vue?vue&type=script&lang=js&"
export * from "./done.vue?vue&type=script&lang=js&"
import style0 from "./done.vue?vue&type=style&index=0&id=1b9cc57a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9cc57a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9cc57a')) {
      api.createRecord('1b9cc57a', component.options)
    } else {
      api.reload('1b9cc57a', component.options)
    }
    module.hot.accept("./done.vue?vue&type=template&id=1b9cc57a&scoped=true&", function () {
      api.rerender('1b9cc57a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/done.vue"
export default component.exports